<script setup lang="ts">
import { FullScreenLoader } from '@/components/LoadingSpinner'
import CreateUserView from '@/components/User/Detail/CreateUserView.vue'
import { ADMIN_USERS_ROUTES } from '@/router/routing/adminRouting/adminRoutes'
import store from '@/store'
import { EStoreModules } from '@/store/storeType'
import { defaultUserModel, type UserModel } from '@/types/models/UserModel'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { EUserActions } from '../../../../store/userStore/UserStoreTypes'

const router = useRouter()

const submitted = ref(false)
const isLoading = computed(() => store.state.user.isLoading)
const userValue = ref<Partial<UserModel>>({ ...defaultUserModel })

const updateUserValue = (value: Partial<UserModel>) =>
    (userValue.value = { ...userValue.value, ...value })

const createUser = () => {
    submitted.value = true
    if (!userValue.value.email || !userValue.value.name) return
    return store
        .dispatch(`${EStoreModules.USER}/${EUserActions.CREATE_USER}`, userValue.value)
        .then(res => {
            submitted.value = false
            router.replace(ADMIN_USERS_ROUTES.buildUrl(res.id))
        })
}
</script>

<template>
    <FullScreenLoader :isLoading="!!isLoading" />
    <CreateUserView
        :data="userValue"
        :submitted="submitted"
        @click="createUser"
        @update="updateUserValue"></CreateUserView>
</template>
